// Reemplaza este valor por el ID de tu píxel de Meta.
export const META_PIXEL_ID = '1253408751196762'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
  push?: unknown
  loaded?: boolean
  version?: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
  }
}

function ensureFbq(): Fbq | null {
  if (typeof window === 'undefined') return null
  if (window.fbq) return window.fbq

  const fbq: Fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
    } else {
      fbq.queue?.push(args)
    }
  } as Fbq

  fbq.queue = []
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.push = fbq

  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  return fbq
}

let initialized = false

/** Inicializa el píxel y dispara PageView una sola vez. */
export function initMetaPixel() {
  if (initialized) return
  const fbq = ensureFbq()
  if (!fbq) return

  initialized = true
  if (META_PIXEL_ID) {
    fbq('init', META_PIXEL_ID)
  }
  fbq('track', 'PageView')
}

/** Dispara un evento estándar del píxel (AddToCart, InitiateCheckout, etc.). */
export function trackEvent(
  eventName: string,
  params?: Record<string, unknown>,
) {
  const fbq = ensureFbq()
  if (!fbq) return
  fbq('track', eventName, params)
}
